import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonIT from '../locales/it/common.json';
import adminIT from '../locales/it/admin.json';
import audienceIT from '../locales/it/audience.json';
import displayIT from '../locales/it/display.json';

import commonEN from '../locales/en/common.json';
import adminEN from '../locales/en/admin.json';
import audienceEN from '../locales/en/audience.json';
import displayEN from '../locales/en/display.json';

// Initialize i18next
i18n
  .use(LanguageDetector) // Detects language from localStorage/navigator
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources: {
      it: {
        common: commonIT,
        admin: adminIT,
        audience: audienceIT,
        display: displayIT,
      },
      en: {
        common: commonEN,
        admin: adminEN,
        audience: audienceEN,
        display: displayEN,
      },
    },
    defaultNS: 'common', // Default namespace
    fallbackLng: 'it', // Default language: Italian
    lng: 'it', // Initial language: Italian

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // Order of detection
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false, // Disable suspense for now to avoid SSR issues
    },
  });

export default i18n;
